import { useResource } from '@landsbankinn/l16n';

import { Dropdown } from '@landsbankinn/ui';
import React from 'react';
import { Region } from '../../../../__generated__/globalTypes';
import res from './RegionFilter.res';

export function useRegionOptions() {
  const { r } = useResource();

  return {
    options: [
      { value: Region.All, label: r(res.allregions) },
      { value: Region.Hofudborgarsvaedid, label: r(res.capitalRegion) },
      { value: Region.Sudurnes, label: r(res.suðurnesPeninsula) },
      { value: Region.Vesturland, label: r(res.westIceland) },
      { value: Region.Vestfirdir, label: r(res.westFjords) },
      { value: Region.Nordurland, label: r(res.northIceland) },
      { value: Region.Austurland, label: r(res.eastIceland) },
      { value: Region.Sudurland, label: r(res.southIcelan) },
    ],
  };
}

interface IProps {
  selectedRegion: Region;
  setSelectedRegion: React.Dispatch<React.SetStateAction<Region>>;
  className?: string;
}

export function RegionDropdown({
  selectedRegion,
  setSelectedRegion,
  className,
}: IProps) {
  const { options } = useRegionOptions();
  const value = options.find((i) => i.value === selectedRegion);
  return (
    <div className={className}>
      <Dropdown
        buildOption={(val) => val}
        onChange={(value) => setSelectedRegion(Region[value?.['value'] as any])}
        options={options}
        value={value}
        variant="noBorder"
      />
    </div>
  );
}
